<template>
  <router-view />
</template>
<script>
import { routeState } from "@/utils/routeState.js";
export default {
  data() {
    return {
      onLine: navigator.onLine,
    };
  },

  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },

  beforeUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },

  methods: {
    updateOnlineStatus() {
      this.onLine = navigator.onLine;

      if (!this.onLine) {
        if (this.$route.name !== "NetworkDisconnect") {
          this.$router.replace({ name: "NetworkDisconnect" });
        }
      } else {
        if (this.$route.name === "NetworkDisconnect") {
          this.$router.replace(routeState.lastRoute || "/");
        }
      }
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
